// ---------------------------------------------------------------------------
// Shared access-token-freshness tracking — used by BOTH axiosInstance
// (encrypted API calls) and plainAxios (Subscription "plain params" calls,
// see GetPlainRequestSlice.js) so a single login/refresh keeps every API
// surface in sync, instead of each axios instance tracking its own copy.
//
// Persisted to localStorage (not just an in-memory variable) so a page
// reload (F5, direct URL open) — or a tab closed and reopened, which
// sessionStorage would forget — still knows when the token was issued.
// Without that, the first request always assumed "token is fresh" and ate
// a real 401 before the reactive refresh kicked in.
// ---------------------------------------------------------------------------
const TOKEN_ISSUED_AT_KEY = "tokenIssuedAt";
const TOKEN_LIFETIME_MS = 60 * 1000; // backend: 1 min access token
const SAFETY_MARGIN_MS = 10 * 1000; // 10s buffer

let lastTokenIssuedAt = Number(localStorage.getItem(TOKEN_ISSUED_AT_KEY)) || 0;

export function markTokenIssued() {
  lastTokenIssuedAt = Date.now();
  localStorage.setItem(TOKEN_ISSUED_AT_KEY, String(lastTokenIssuedAt));
}

export function isTokenLikelyExpired() {
  if (!lastTokenIssuedAt) return false;
  return Date.now() - lastTokenIssuedAt > TOKEN_LIFETIME_MS - SAFETY_MARGIN_MS;
}
